// @flow

export { EfectyPageContent } from './colombia';
export { ArgentineCashPageContent } from './argentina';
